import './lib/extensions'
import 'animate.css'
import 'devextreme/dist/css/dx.common.css'
import './registerServiceWorker'

import 'quasar/src/css/index.sass'

import { createApp } from 'vue'

import App from './App.vue'
import i18n from './plugins/i18n'
import pinia from './plugins/pinia'
import router from './router'
import dayjs from './plugins/dayjs'
import { Quasar } from 'quasar'
import quasarUserOptions from './plugins/quasar'
import httpApi from './plugins/httpapi'
import dragDialog from './plugins/drag-dialog'

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(pinia)
  .use(i18n)
  .use(dayjs)
  .use(httpApi)
  .use(dragDialog)
  .use(router)
  .mount('#app')

// Dev-extreme
import '@/plugins/devextreme'
import '@/styles/style.scss'
